import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { toast } from "react-toastify";
import { useUsers } from "../../hooks/useRedux";
import UserForm from "./UserForm";
import { User } from "../../store/slices/types";

const AddUser: React.FC = () => {
  const navigate = useNavigate();
  const { createUser } = useUsers();

  const handleSave = async (userData: Partial<User>) => {
    try {
      const newUser = {
        email: userData.email || "",
        username: userData.username || "",
        displayName: userData.displayName || "",
        preferences: userData.preferences || {
          notifications: true,
          theme: "light",
          language: "en",
          isActive: true,
        },
      };

      await createUser(newUser);
      toast.success("user is created");
      navigate("/users");
    } catch (error) {
      console.error("Failed to create user:", error);
      toast.error(
        `❌ Failed to create user: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate("/users");
  };

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Create New User
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Add a new user to your system
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <UserForm
          user={null}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default AddUser;

